/**
 * Labstep
 *
 * @module grid/SmartTableProtocolCondition/components/ToolPanel/Section
 * @desc Entity DataGrid column options section for shown/hidden fields
 */

import { Header } from 'labstep-web/core/Header';
import { Sortable } from 'labstep-web/core/Sortable';
import { EntityDataGridToolPanelSectionItem } from 'labstep-web/grid/SmartTableProtocolCondition/components/ToolPanel/Section/Item';
import { GridSmartTableProtocolConditionService } from 'labstep-web/grid/SmartTableProtocolCondition/services/grid-smart-table-protocol-condition.service';
import { SectionType } from 'labstep-web/grid/services/grid.service';
import type React from 'react';
import { useMemo } from 'react';
import type {
  ColumnWithId,
  IEntityDataGridToolPanelSectionProps,
} from './types';

export const EntityDataGridToolPanelSection: React.FC<
  IEntityDataGridToolPanelSectionProps
> = ({ columns, section, onToggleColumnVisible, onSortColumns }) => {
  if (!columns.length) {
    return null;
  }
  const items: { id: string; column: ColumnWithId }[] = useMemo(
    () =>
      GridSmartTableProtocolConditionService.columnsToItems(columns),
    [columns],
  );

  const onSortEnd: Parameters<typeof Sortable>[0]['onSortEnd'] =
    useMemo(
      () =>
        GridSmartTableProtocolConditionService.onSortEndColumns(
          items,
          onSortColumns,
        ),
      [items, onSortColumns],
    );

  return (
    <div style={{ overflowY: 'auto' }}>
      {section === SectionType.hidden && (
        <Header size="mini">Hidden</Header>
      )}
      <Sortable
        /** dnd-kit transform does not work with overlay in this case */
        hideOverlay
        items={items}
        onSortEnd={onSortEnd}
        renderItem={({ column }): JSX.Element => (
          <EntityDataGridToolPanelSectionItem
            key={column.getColId()}
            column={column}
            section={section}
            onToggleColumnVisible={onToggleColumnVisible}
          />
        )}
      />
    </div>
  );
};
